import { render, staticRenderFns } from "./edit-moiepuipment.vue?vue&type=template&id=483d112a&"
import script from "./edit-moiepuipment.vue?vue&type=script&lang=ts&"
export * from "./edit-moiepuipment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports